import React, { useEffect, useState } from 'react'
import { Layout } from '../Layout'
import { Button } from '../../../components/button/button'
import Modal from '../../../components/modals/Modal';
import { Navbar } from '../../../components/navbar/Navbar';
import Input from '../../../components/input/Input';
import Label from '../../../components/title/label';
import * as  XLSX from 'xlsx';
import axios from 'axios'; 
import Loader from '../../../components/loading/loading';
import { Title4 } from '../../../components/title/title';
import { useLocation } from "react-router-dom";
import { ModalError, ModalErrorServer } from '../Modal';
import PasswordInput from '../../../components/input/PasswordInput';
import { BACKEND_URL, E_immatriculation } from '../../../constants/constant';

function Utilitaire() {

  const location = useLocation(); 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [Client , setClient ] = useState([]); 
  const [startDate, setStartDate] = useState(''); 
  const [endDate, setEndDate] = useState('');
  const [isLoading] = useState(false);
  const [ priseEnCharge , setPriseEnCharge] = useState([]);

// Fonction pour formater une date
const formatDate = (isoDate) => {
  if (!isoDate) return "N/A";
  const date = new Date(isoDate);
  return date.toLocaleDateString("fr-FR"); // Format français (jour/mois/année)
};

  useEffect(() => {
    // Récupérer les données depuis le backend
    axios.get(`${BACKEND_URL}/prisecharge`)
      .then((response) => setPriseEnCharge(response.data))
      .catch((error) => {console.error(error);alert(`Il y a une erreur :  ${error}`)});
  }, []);
 
  useEffect(() => {
   // Récupérer les données depuis le backend
   axios.get(`${E_immatriculation}/contribuable`)
     .then((response) => setClient(response.data))
     .catch((error) => {console.error(error);alert(`Il y a une erreur :  ${error}`)});
 }, []); 
  


  

// Filtrage par date_prise_charge
const filteredDataByDate = Client.filter((client) => {
  const matchingPriseEnCharge = priseEnCharge.find(
    (pec) => pec.id_contribuable === client.id
  );

  if (!matchingPriseEnCharge || !matchingPriseEnCharge.date_prise_charge) {
    return false;
  }

  const itemDate = new Date(matchingPriseEnCharge.date_prise_charge);
  const start = startDate ? new Date(startDate) : null;
  const end = endDate ? new Date(endDate) : null;

  return (!start || itemDate >= start) && (!end || itemDate <= end);
}).map((client) => {
  const matchingPriseEnCharge = priseEnCharge.find(
    (pec) => pec.id_contribuable === client.id
  );

  return [
    client.id,
    client.raison_social,
    client.reference_fiscal,
    client.type,
    formatDate(client.date_agrement),
    client.regime_fiscal,
    client.forme_juridique,
    formatDate(client.date_creation),
    client.rib,
    formatDate(matchingPriseEnCharge.date_prise_charge), // Ajouter la date prise en charge
  ];
});

// Mettre à jour les headers pour inclure la nouvelle colonne
const ClientHeaders = [
  "Ref demandé",
  "Raison sociale",
  "Référence fiscale",
  "Type",
  "Date autorisation",
  "Régime fiscal",
  "Forme juridique",
  "Date de création",
  "RIB",
  "Date prise en charge", // Nouvelle colonne
];

  

// Fonction pour exporter en Excel
const exportToExcel = () => {
  if (!startDate || !endDate) {
    alert("Veuillez sélectionner une plage de dates.");
    return;
  }

  const excelData = [ClientHeaders, ...filteredDataByDate]; // Inclure les données filtrées

  // Créer et télécharger le fichier Excel
  const worksheet = XLSX.utils.aoa_to_sheet(excelData); // Transforme en feuille Excel
  const workbook = XLSX.utils.book_new(); // Nouveau classeur
  XLSX.utils.book_append_sheet(workbook, worksheet, "Clients"); // Ajoute la feuille
  XLSX.writeFile(workbook, "Utilitaires.xlsx"); // Télécharge
};

  //Login fonction 
  const [code, setCode] = useState('');
  const [mdp, setMdp] = useState('');
  
  const [isModalError, setIsModalError] = useState(false);
  const [isModalErrorServer, setIsModalErrorServer] = useState(false);
  
  const handleLogin = () => {
    // Replace with your API endpoint for user authentication
    const apiUrl = `${BACKEND_URL}/user/auth`;

    // Create a request body with user input
    const requestBody = {
      "code": code,
      "mdp": mdp,
    };

    axios
      .post(apiUrl, requestBody)
      .then((response) => {
        const userData = response.data;
        console.log(userData)
        // Check if the user is authenticated and has immatriculation_prise_charge set to true
        if (userData.login && userData.immatriculation_prise_charge) {
          // Redirect to the desired page if the condition is met
          setIsModalOpen(true);
          setCode('');
          setMdp('');
        } else {
          setIsModalError(true);
        }
      })
      .catch((error) => {
        console.error('Login error:', error);
       
        setIsModalErrorServer(true);
      });
  };



  
    const NavbarModal =(
        
        <div className='text-white'>
      Obtention de copie du fichier immatriculation
        </div>
        
      )
    const contentChildren =(
        <div >
            
            <div className='flex  justify-center  mt-14 '>
        <div className='w-[500px] h-[500px] bg-[#212122] rounded-xl flex justify-center'>
          <div className='mt-8 flex flex-col p-4 w-[400px]'>
            <Label className="text-5xl" text="Utilitaire"></Label>
            <div className='flex flex-col mt-8'>
              <Label text="Code"></Label>
              <Input type="text" placeholder="Votre code" value={code} onChange={(e) => setCode(e.target.value)} className="w-full"/>
            </div>
            <div className='flex flex-col mt-4'>
              <Label text="Mot de passe"></Label>
              <PasswordInput value={mdp} onChange={(e)=> setMdp(e.target.value)}></PasswordInput>
            </div>
            <Button type="submit" children="Se connecter" onClick={handleLogin} className="mt-8"></Button>
           
          </div>
        </div>
        <ModalError isOpen={isModalError} onClose={()=> setIsModalError(false)} quitter={()=> setIsModalError(false)}></ModalError>
        <ModalErrorServer isOpen={isModalErrorServer} onClose={()=> setIsModalErrorServer(false)} quitter={()=> setIsModalErrorServer(false)}></ModalErrorServer>
      </div>
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} className="w-[700px] h-[420px] ">
        <Navbar content={NavbarModal} ></Navbar>
        <div className='flex justify-center items-center p-4 '>
       <div className='flex flex-col'>
       <div className='m-2 text-white'>
Il s'agit d'avoir une copie du fichier Immatriculation dans votre ordinateur
            </div>
            <div className='flex justify-between m-2 '>
             <Label text="Du :"></Label>
             <Input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)}></Input>
            </div>
            <div className='flex justify-between  m-2 '>
             <Label text="Au :"></Label>
             <Input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)}></Input>
            </div>
            <div className='flex justify-between  m-2 '>
            <Button  children="Executer la requête"  onClick={exportToExcel} ></Button>
            <Button onClick={() => setIsModalOpen(false)} children="Quitter" ></Button>
            </div>
       </div>
       
        </div>
        {isLoading ? <Loader></Loader> : null}
        </Modal>
        <Modal isOpen={isModal} onClose={() => setIsModal(false)} className="w-[400px] h-[200px] ">
       <div className='flex justify-center item-center p-4'>
       <div className='flex flex-col mt-8'>
       <Title4 text="Aucune donnée trouver"></Title4>
        <Button onClick={() => setIsModal(false)} children="OK" className="mt-4" ></Button>
       
       </div>
       </div>
        </Modal>
        </div>
    
        )
        return (
          <div  className='inset-0 bg-neutral-700 transition-opacity h-screen' >
             <Layout currentPath={location.pathname} children={contentChildren}></Layout>
          </div>
           )
     }

export default Utilitaire